export default {
  summary: {
    delivery: 'Entrega: Cartão oferta em PDF por e-mail',
  },
};
